import { render, staticRenderFns } from "./vue-qz-tray.vue?vue&type=template&id=56310f26&scoped=true&"
import script from "./vue-qz-tray.vue?vue&type=script&lang=js&"
export * from "./vue-qz-tray.vue?vue&type=script&lang=js&"
import style0 from "./vue-qz-tray.vue?vue&type=style&index=0&id=56310f26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56310f26",
  null
  
)

export default component.exports